import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';

import { classes } from './styles';

interface PageLoaderProps {
  children?: React.ReactNode;
  requiredComponents?: string[];
}

const DEFAULT_REQUIRED_COMPONENTS = [
  '[data-react-class*="WCAG/Header"]',
  '[data-react-class*="WCAG/ApplicationFlow"]',
  '[data-react-class*="WCAG/ApplyNow"]'
];

export const PageLoader: React.FC<PageLoaderProps> = ({
  children,
  requiredComponents = DEFAULT_REQUIRED_COMPONENTS
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkComponentsReady = () => {
      const allReady = requiredComponents.every((selector) => {
        const element = document.querySelector(selector);
        return element && element.children.length > 0;
      });

      if (allReady) {
        setIsLoading(false);
        document.body.classList.add('wcag-components-ready');
      }
    };

    const intervalId = setInterval(checkComponentsReady, 50);
    checkComponentsReady();

    const timeoutId = setTimeout(() => {
      setIsLoading(false);
      document.body.classList.add('wcag-components-ready');
    }, 2000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [requiredComponents]);

  if (isLoading) {
    return <Box sx={classes.pageLoader.loadingContainerSx()}>{children}</Box>;
  }

  return <>{children}</>;
};

export default PageLoader;
